module.exports = __webpack_public_path__ + "static/media/175884A.ac323b99.jpg";